<template>
  <v-row class="my-0">
    <v-col
      cols="12"
      sm="6"
    >
      <slot name="form" />
    </v-col>
    <v-col
      cols="12"
      sm="6"
    >
      <slot name="text" />
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: "FormInstruction",
}
</script>

<style scoped>

</style>
